module.exports = __webpack_public_path__ + "media/images/trophy-7f684334e55df02cc815587227fdf204.svg";